import { NotificationType } from '../enums';

export const COURSE_NOTIFICATION_FANOUT_BATCH = 50;
export const COURSE_QA_MAX_REPLY_DEPTH = 2;

export function isCourseInAppOnlyNotificationType(type: NotificationType): boolean {
  return (
    type === NotificationType.COURSE_NEW_LESSON || type === NotificationType.COURSE_QA_REPLY
  );
}

export function isCourseAccountEmailNotificationType(type: NotificationType): boolean {
  return type === NotificationType.COURSE_PURCHASE_RECEIPT;
}

export function buildCourseLearnHref(courseSlug: string | null, lessonId?: string): string {
  if (!courseSlug) return '/learning';
  const base = `/courses/${courseSlug}/learn`;
  return lessonId ? `${base}?lesson=${lessonId}` : base;
}

export function buildCourseNewLessonSummary(courseTitle: string, lessonTitle: string): string {
  return `New lesson in ${courseTitle}: ${lessonTitle}`;
}

export function buildCourseEnrolledSummary(courseTitle: string): string {
  return `You're enrolled in ${courseTitle}`;
}

export function buildCoursePurchaseReceiptSummary(courseTitle: string, amountLabel: string): string {
  return `Receipt for ${courseTitle} (${amountLabel})`;
}

export function buildCourseQaReplySummary(courseTitle: string, lessonTitle: string): string {
  return `Reply on ${lessonTitle} in ${courseTitle}`;
}

export function formatCoursePurchaseAmount(amountCents: number, currency: string): string {
  const amount = amountCents / 100;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency.toUpperCase()}`;
  }
}

export function resolveCourseQaReplyRecipient(params: {
  parentAuthorId: string | null;
  courseCreatorUserId: string;
  actorUserId: string;
}): string | null {
  const recipientId = params.parentAuthorId ?? params.courseCreatorUserId;
  if (!recipientId || recipientId === params.actorUserId) return null;
  return recipientId;
}
